import { Header, LwButton, LwTab, Page, Toolbox } from 'redesign';
import { IconAdd } from 'assets/img';
import { Box, styled, Tabs, tabsClasses } from '@mui/material';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { InternalFlexPools } from './components/internal-flexpools/internal-flexpools';
import { ExternalFlexPools } from './components/external-flexpools/external-flexpools';
import { DepartmentSelect } from '../../components';

type FlexpoolTab = 'internal' | 'external';

export const FlexPools = () => {
  const [selectedTab, setSelectedTab] = useState<FlexpoolTab>('internal');
  const { t } = useTranslation('ogp-screen-specific');

  return (
    <>
      <Page
        header={
          <HeaderContainer>
            <Header
              titleText={t('flexpools.title', { ns: 'ogp-screen-specific' })}
              subheaderText={t('flexpools.subheader', { ns: 'ogp-screen-specific' })}
            />
            <FlexpoolTabs
              value={selectedTab}
              onChange={(event, tabId) => {
                setSelectedTab(tabId);
              }}
              aria-label="tabbladen"
            >
              <LwTab
                key={'internal'}
                value={'internal'}
                label={t('flexpools.tabs.internal', { ns: 'ogp-screen-specific' })}
              />
              <LwTab
                key={'external'}
                value={'external'}
                label={t('flexpools.tabs.external', { ns: 'ogp-screen-specific' })}
              />
            </FlexpoolTabs>
          </HeaderContainer>
        }
        toolbox={
          <Toolbox>
            <LwButton
              to={selectedTab === 'internal' ? 'create' : 'external/create'}
              color="primary"
              startIcon={<IconAdd />}
              iconColorMode="fill"
            >
              {t('flexpools.create_button', { ns: 'ogp-screen-specific' })}
            </LwButton>
            <Toolbox.PushRight>
              {selectedTab === 'internal' ? <DepartmentSelect /> : null}
            </Toolbox.PushRight>
          </Toolbox>
        }
      >
        {selectedTab === 'internal' ? <InternalFlexPools /> : <ExternalFlexPools />}
      </Page>
    </>
  );
};

const HeaderContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  alignItems: 'flex-start',
  marginBottom: theme.spacing(6),
}));

const FlexpoolTabs = styled(Tabs)(({ theme }) => ({
  minHeight: 'unset',
  [`& .${tabsClasses.flexContainer}`]: {
    gap: theme.spacing(8),
  },
}));
